<template>
  <div class="management">
    <!-- 抬头 -->
    <div class="head">
      <div class="head-left">
        <h4>项目管理</h4>
      </div>
      <div class="head-right">
        <div class="head-right-input">
          <el-input :clearable="true" placeholder="请输入项目名称" v-model="managementInput" clearable @change="change">
          </el-input>
          <el-button size="medium" style="background: #484c7f; color: #fff" @click="searchmanagemen">搜索</el-button>
        </div>
        <div class="head-right-btn">
          <el-button size="medium" style="background: #258ce8; color: #fff" @click="addnewItemsClick">新建项目</el-button>
        </div>
      </div>
    </div>
    <!-- 抬头结束 -->
    <!-- 公告 -->
    <div class="announcement">
      <div class="announcement-top">
        <div class="announcement-top-img">
          <img src="../../assets/image/books/gonggao.png">
        </div>
        <div class="announcement-top-text">公告</div>
      </div>
      <div class="announcement-bottom">
        <el-carousel indicator-position="outside" :interval="5000">
          <el-carousel-item v-for="(item, index) in announcement" :key="index">
            <div>{{ item.content }}</div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <!-- 公告 -->
    <!-- 内容 -->
    <ul class="contents">
      <div>
        <li class="contents-item" v-for="(item, index) in questionnairesObject.list" :key="index">
          <!-- 左侧 -->
          <div class="contents-item-left">
            <div class="contents-item-left-img">
              <img :src="item.logo">
            </div>
            <div class="contents-item-left-text">
              <div class="contents-item-left-text-t">
                {{ item.project_name }}
              </div>
              <div class="contents-item-left-text-time">{{ item.create_time }}
              </div>
            </div>
          </div>
          <!-- 左侧 -->
          <!-- 右侧 -->
          <div class="contents-item-right">
            <div class="contents-item-right-img" @click="editorProjectsClick(item)">
              <div class="contents-item-right-img-1"><img src="../../assets/image/books/b.png"></div>
              <div class="contents-item-right-text">编辑项目</div>
            </div>

            <div class="contents-item-right-img" @click="specialistProfilesClick(item)">
              <div class="contents-item-right-img-2"><img src="../../assets/image/books/d.png"></div>
              <div class="contents-item-right-text">专家档案</div>
            </div>

            <div class="contents-item-right-img" @click="downloadAgreement(item)">
              <div class="contents-item-right-img-3"><img src="../../assets/image/books/x.png"></div>
              <div class="contents-item-right-text">下载协议</div>
            </div>

            <div class="contents-item-right-img" @click="deleteClick(item)">
              <div class="contents-item-right-img-4"><img src="../../assets/image/books/s.png"></div>
              <div class="contents-item-right-text">删除</div>
            </div>
          </div>
          <!-- 右侧 -->
        </li>
      </div>
      <div class="not-available" v-if="questionnairesObject.list.length == 0">暂无数据</div>
    </ul>
    <!-- 内容 -->
    <!-- 新建项目 -->
    <el-dialog title="添加项目" :visible.sync="newItems" width="30%">
      <!-- 内容 -->
      <div class="add-projects">
        <div class="add-projects-top">
          <div class="must">*</div>
          <div class="add-projects-top-name">项目名称</div>
          <el-input v-model="addinput" placeholder="请输入内容"></el-input>
        </div>
        <div class="add-projects-bottom">
          <div class="must">*</div>
          <div class="add-projects-bottom-name">项目logo</div>
          <el-upload name="file" class="avatar-uploader" :action="action" :show-file-list="false"
            :on-success="handleAvatarSuccess" :data="{ file: 'file', model: '' }" ref="imageUrl">
            <img v-if="imageUrl" :src="imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
      </div>
      <!-- 内容 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="newItems = false">取 消</el-button>
        <el-button type="primary" @click="documentationCreate">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 新建项目 -->
    <!-- 编辑项目 -->
    <el-dialog title="编辑项目" :visible.sync="editorProjects" width="30%">
      <!-- 内容 -->
      <div class="add-projects">
        <div class="add-projects-top">
          <div class="must">*</div>
          <div class="add-projects-top-name">项目名称</div>
          <el-input v-model="editorinput" placeholder="请输入内容"></el-input>
        </div>
        <div class="add-projects-bottom">
          <div class="must">*</div>
          <div class="add-projects-bottom-name">项目logo</div>
          <el-upload name="file" class="avatar-uploader" :action="action" :show-file-list="false"
            :on-success="handleAvatarSuccess" :data="{ file: 'file', model: '' }" ref="imageUrl">
            <img v-if="imageUrl" :src="imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
      </div>
      <!-- 内容 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="editorProjects = false">取 消</el-button>
        <el-button type="primary" @click="confirmationeDitorProjects">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 编辑项目 -->
    <div class="page" v-show="questionnairesObject.list != 0">
      <el-pagination background layout="prev, pager, next" @current-change="currentchange" @prev-click="prevClick"
        @next-click="nextClick" :page-count="questionnairesObject.pages" :current-page.sync="currentPage">
      </el-pagination>
    </div>
  </div>
</template>
 
<script>
export default {
  name: 'booksManagement',
  data() {
    return {
      announcement: [],
      managementInput: '',
      newItems: false,
      editorProjects: false,
      addinput: '',
      editorinput: '',
      imageUrl: "", //创建
      imageUrlBackstage: '',//创建头像 传入后台
      editorProjectsID: '',
      editorimageUrl: '',
      action: `https://laravel.gongshicloud.com/api/index/upload`,
      pagesize: 8,//每页显示条目个数
      currentPage: 1,//当前页数  
      list: [0, 1, 2, 3],
      questionnairesObject: { list: [] }
    }
  },
  activated() {
    this.getAnnouncement()//公告
    this.getProjectsList()//列表
  },
  methods: {
    //公告通知
    async getAnnouncement() {
      const { data: data } = await this.$http.get('library/notice')
      this.announcement = data.data
    },
    //抬头回车  
    change(value) {
      this.managementInput = value
      this.currentPage = 1
      setTimeout(() => {
        this.getProjectsList()
      }, 500)
      this.$Spin.show();
    },
    //搜索按钮
    searchmanagemen() {
      this.currentPage = 1
      setTimeout(() => {
        this.getProjectsList()
      }, 500)
      this.$Spin.show();
    },
    //获取项目列表
    async getProjectsList() {
      const { data: data } = await this.$http.post('library/projectList', {
        name: this.managementInput,
        limit: this.pagesize,//每页条数 
        page: this.currentPage,//第几页 
      })
      this.questionnairesObject = data.data
      this.$Spin.hide();
    },
    //新建项目弹窗
    addnewItemsClick() {
      this.newItems = true
      this.imageUrl = ''
      this.addinput = ''
    },
    //新建项目  
    async documentationCreate() {
      const { data: data } = await this.$http.post('library/createProject', {
        project_name: this.addinput,
        logo: this.imageUrlBackstage,
        id: '',//创建为空，修改传参 
      })
      this.$message({
        message: data.message,
        type: 'success'
      });
      this.newItems = false
      this.getProjectsList()
    },
    //打开编辑项目 
    editorProjectsClick(item) {
      this.editorinput = item.name
      this.imageUrl = item.logo
      this.imageUrlBackstage = item.logo
      this.editorProjects = true
      this.editorProjectsID = item.id
    },
    //确认修改编辑项目
    async confirmationeDitorProjects() {
      const { data: data } = await this.$http.post('library/createProject', {
        project_name: this.editorinput,
        logo: this.imageUrlBackstage,
        id: this.editorProjectsID,//创建为空，修改传参 
      })
      this.$message({
        message: data.message,
        type: 'success'
      });
      this.editorProjects = false
      this.getProjectsList()
    },
    //专家档案 
    specialistProfilesClick(item) {
      this.$router.push({
        path: 'booksArchives',
        query: {
          id: item.id
        }
      })
    },
    //下载协议
    async downloadAgreement(item) {
      const { data: data } = await this.$http.post('library/download', { id: item.id })
      if (data.data.url == '') {
        this.$message({
          message: '暂无协议',
          type: 'warning'
        });
      } else {
        window.open(data.data.url)
      }
    },
    //删除  
    deleteClick(item) {
      this.$confirm(' 该项目删除后，项目下的相关人员档案、文献等信息也会删除，确定要删除该项目吗？?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: data } = await this.$http.post('library/deleteProject', { id: item.id })
        this.getProjectsList()
        this.$message({
          message: data.message,
          type: 'success'
        });
      }).catch(() => { })
    },
    //新建 上传图片 
    handleAvatarSuccess(res, file, fileList) {
      if (res.code != 200) {
        this.$refs.imageUrl.clearFiles()
        this.$message.error(res.message)
        return
      }
      this.$Loading.finish()
      this.imageUrl = URL.createObjectURL(file.raw);
      this.imageUrlBackstage = res.data.url
    },
    //点击每一页  
    currentchange(e) {
      this.currentPage = e
      setTimeout(() => {
        // this.getExpertList()
      }, 500)
      this.$Spin.show();
    },
    //上一页  
    prevClick(e) {
      this.currentPage = e
      setTimeout(() => {
        // this.getExpertList()
      }, 500)
      this.$Spin.show();
    },
    //下一页 
    nextClick(e) {
      this.currentPage = e
      setTimeout(() => {
        // this.getExpertList()
      }, 500)
      this.$Spin.show();
    },
  }
}

</script>  
<style lang="less" scoped>
.management {

  //头部
  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e8e8e8;
    padding-bottom: 16px;
    margin-bottom: 23px;

    .head-left {
      h4 {
        font-size: 28px;
        color: #212529;
      }
    }

    .head-right {
      display: flex;

      .head-right-input {
        display: flex;
        align-items: center;

        /deep/.el-input {
          width: 332px;
          flex: 1;
          margin-right: 16px;
        }
      }

      .head-right-btn {
        margin-left: 190px;
      }
    }
  }

  //公告
  .announcement {
    width: 100%;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
    padding: 20px 30px 25px 30px;

    .announcement-top {
      display: flex;
      align-items: center;

      .announcement-top-img {
        width: 19px;
        height: 19px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .announcement-top-text {
        margin-left: 10px;
        font-size: 16px;
        color: #212529;
        font-weight: 600;
        margin-top: 3px;
      }
    }

    .announcement-bottom {
      height: 20px;
      overflow: hidden;
      margin-top: 25px;
      font-size: 15px;
      color: #212529;
    }
  }

  //内容
  .contents {
    width: 100%;
    min-height: 530px;
    padding: 0 30px 50px 30px;
    background-color: #fff;
    margin-top: 22px;
    border-radius: 8px;
    box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);

    //每一个内容
    .contents-item {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      padding: 38px 0;
      border-bottom: 0.5px solid #e8e8e8;

      .contents-item-left {
        display: flex;

        .contents-item-left-img {
          width: 193px;
          height: 83px;
          margin-right: 22px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .contents-item-left-text {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          // width: 753px;
          max-width: 753px;

          .contents-item-left-text-t {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            color: #212529;
          }

          .contents-item-left-text-time {
            font-size: 14px;
            color: #c7c7c7;
          }
        }
      }

      .contents-item-right {
        display: flex;
        position: relative;
        top: 39px;
        right: 0;
        border: 0.5px solid #ebebeb;
        border-bottom: 0px;
        cursor: pointer;

        .contents-item-right-img {
          display: flex;
          align-items: center;
          padding: 12px 17px;
          border-right: 0.5px solid #ebebeb;

          &:last-child {
            border-right: 0;
          }

          .contents-item-right-img-1 {
            width: 20px;
            height: 20px;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .contents-item-right-img-2 {
            width: 17px;
            height: 20px;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .contents-item-right-img-3 {
            width: 18px;
            height: 19px;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .contents-item-right-img-4 {
            width: 17px;
            height: 19px;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .contents-item-right-text {
            margin-left: 5px;
            font-size: 14px;
            color: #212529;
          }
        }
      }
    }
  }

  //添加项目弹窗
  .add-projects {
    .add-projects-top {
      display: flex;
      align-items: center;

      .add-projects-top-name {
        width: 90px;
      }
    }

    .add-projects-bottom {
      display: flex;
      align-items: center;
      margin-top: 45px;

      .add-projects-bottom-name {
        width: 77px;
      }
    }

    // 上传图片
    /deep/ .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 156px;
      height: 66px;
      line-height: 66px;
      text-align: center;
    }

    .avatar {
      width: 156px;
      height: 66px;
      display: block;
    }

    .must {
      font-size: 18px;
      color: #ff0d0d;
      margin-right: 6px;
    }
  }

  //分页
  .page {
    margin-top: 20px;
    text-align: right;
  }

  //暂无数据
  .not-available {
    position: absolute;
    top: 63%;
    left: 55%;
  }
}
</style> 